import { Component, HostListener, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { Plant } from 'src/app/model/device-vct/device-vct-implant';
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';

@Component({
	templateUrl: './vct-abandon-plant.dialog.component.html',
})

export class VctAbandonPlantDialogComponent implements OnInit {
	device: Plant;

	abandonForm: FormGroup;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.device = config.data.device;
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	buildForm(): void {
		this.abandonForm = new FormGroup({
			'cleanup': new FormControl(false),
		});
	}

	initSelectors(): void {
		// Store selectors
	}

	subscribeAll(): void {
	}

	// ngOnDestroy(): void {
	// }

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.abandonForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.abandonForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const cleanupValue = this.f.cleanup.value;

		this.store.dispatch(DeviceVctActions.abandonVctPlant({ plantId: this.device.DeviceId, cleanup: cleanupValue }));

		this.closeDialog();
	}

	get f(): any {
		return this.abandonForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth() : string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth,'w-20rem');
	}

	dynamicInputTextDesktopTabletWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-40rem', 'w-23rem');
	}

	justifyMessagesNewValidator(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}
}
